/**
 * UNRELEASED UI GATES
 * ===================
 *
 * Some UI is built in its final place before the capability behind it exists, so the surface
 * never has to be redesigned later. A gate keeps that UI out of a real member's hands until the
 * thing it describes is actually true.
 *
 * Two signals, in this order:
 *
 *   1. `REACT_APP_UNRELEASED_UI` — a build-time list. Production sets nothing, so production
 *      renders nothing. This is the only signal that can ever ship.
 *   2. `window.__ARVEXIS_UNRELEASED_UI` — set by a verification script BEFORE the app boots.
 *      It exists so the Founder can see a gated surface deterministically without fabricating
 *      configuration or faking backend behaviour.
 *
 * A gate controls VISIBILITY ONLY. Gated UI is rendered non-interactive, persists nothing, and
 * makes no promise: showing a control is not the same as the control working.
 */

export const UNRELEASED = {
  CONVERSATION_HANDOFF: 'conversation_handoff',
};

const fromBuild = (process.env.REACT_APP_UNRELEASED_UI || '')
  .split(',')
  .map((name) => name.trim())
  .filter(Boolean);

export const isUnreleasedVisible = (name) => {
  if (fromBuild.includes(name)) return true;
  const internal = typeof window !== 'undefined' ? window.__ARVEXIS_UNRELEASED_UI : null;
  return Array.isArray(internal) && internal.includes(name);
};
